import { Component, OnInit, Input } from '@angular/core';
import { UnitLayout } from '../../model/layout';
import { CvdsUtilsService } from '../../service';

@Component({
	selector: 'cv-cvds-unit',
	templateUrl: './cvds-unit.component.html',
	styleUrls: ['../../cvds-structures.component.scss']
})
export class CvdsUnitComponent implements OnInit {
	@Input() unit: any;
	@Input() index: number;

	fieldsModel = [];
	fieldsSections = [];

	constructor(private utilsService: CvdsUtilsService) {}

	async ngOnInit(): Promise<void> {
		const layout = new UnitLayout();
		this.fieldsModel = this.utilsService.mapFields(this.unit, layout.fields);

		layout.fieldsArray.forEach(item => {
			const { fieldName, label, fields } = item;
			if (Object.prototype.hasOwnProperty.call(this.unit, fieldName)) {
				this.fieldsSections.push({
					items: this.unit[fieldName],
					fields: fields,
					title: label
				});
			}
		});
	}
}
